import React from 'react'

const ChevronRight = ({ size = 14, color = '#129878', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={(size * 8) / 14} 
    height={size}
    viewBox="0 0 8 14"
    fill="none"
    {...props}
  >
    <path
      d="M1 13L7 7L1 1"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ChevronRight
